import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Grid,
  IconButton,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { addCardDetails, getDejavooToken } from "../../plugins/ApiHandler";
import AddCardForm from "../../components/AddPayment/AddCardForm";
import "./style.css";
import showToast from "../Toast/Toster";
import { useUserType } from "../../contexts/UserTypeContext";
import { getItem } from "../../utils/storage";

const AddCardDetailsForm = (props) => {
  const [loading, setLoading] = useState(false);
  const { userType } = useUserType();
  const isDonationMode = userType === "donor";

  const addCardInfo = async (data) => {
    const CompanyId = getItem("CompanyId") || props?.CompanyId;
    const CustomerIds = props.CustomerId;

    data.CompanyId = CompanyId || "";
    data.CustomerId = CustomerIds || "";
    data.type = "card";
    data.Gateway = (data.Gateway || props?.Gateway || "").toString().toUpperCase();

    try {
      setLoading(true);
      // Dejavoo: only dejavoo-tokenize-card API (tokenize + save card in one call; add-dejavoo-customer-card removed)
      if (data.Gateway === "DEJAVOO") {
        await getDejavooToken(CompanyId, data);
        props.onHide();
        showToast.success("Card added successfully");
        props.fetchData();
        return;
      }
      await addCardDetails(data);
      props.onHide();
      showToast.success("Card added successfully");
      props.fetchData();
    } catch (error) {
      // Axios interceptor may reject with the message string directly; backend returns { status, message }
      let errorMessage = "Failed to add card. Please check your card details and try again.";
      if (typeof error === "string" && error.trim()) {
        errorMessage = error.trim();
      } else if (error && typeof error === "object") {
        const msg =
          error?.response?.data?.message ||
          error?.response?.data?.data?.error ||
          error?.response?.data?.error ||
          error?.message;
        if (msg != null && String(msg).trim()) errorMessage = String(msg).trim();
      }
      showToast.error(errorMessage);
      console.error("Add card failed:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Dialog
        open={props?.show}
        onClose={props?.onHide}
        fullWidth
        maxWidth="md"
        scroll="paper"
      >
        <DialogTitle
          className={`${
            isDonationMode ? "border-donor-color" : "border-orange-color"
          }`}
          style={{ borderBottom: "2px solid" }}
          sx={{ px: 1.5, pt: 2, pb: 1.5 }}
        >
          <Grid className="d-flex justify-content-between align-items-center">
            <Grid component="span" sx={{ minWidth: 0 }}>
              <Typography
                variant="h5"
                className={`text-lg cardInformationDetail ${
                  isDonationMode ? "text-donor-color" : "text-blue-color"
                }`}
                style={{ fontWeight: "bold", fontSize: "18px" }}
              >
                User Information
              </Typography>
            </Grid>
            <Grid>
              <IconButton
                aria-label="close"
                size="small"
                onClick={props?.onHide}
                sx={{
                  color: isDonationMode
                    ? "var(--bg-donor-color)"
                    : "var(--text-blue-color)",
                  "& .MuiSvgIcon-root": { color: "inherit" },
                }}
              >
                <CloseIcon />
              </IconButton>
            </Grid>
          </Grid>
        </DialogTitle>
        <DialogContent
          style={{ paddingTop: 12 }}
          sx={{
            width: "100%",
            maxWidth: "100%",
            boxSizing: "border-box",
            overflowX: "hidden",
            px: 1.5,
            pb: 1.5,
          }}
        >
          <Grid container spacing={2} sx={{ width: "100%", maxWidth: "100%", margin: 0 }}>
            <Grid sx={{ width: "100%", maxWidth: "100%", minWidth: 0 }} size={12}>
              <AddCardForm
                addCardInfo={addCardInfo}
                onHide={props?.onHide}
                CustomerId={props?.CustomerId}
                CompanyId={props?.CompanyId}
                loader={loading}
                Gateway={props?.Gateway}
              />
            </Grid>
          </Grid>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default AddCardDetailsForm;
